'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    height: 30px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n'], ['\n    height: 30px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _metrixCommon = require('metrix-common');

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _Options = require('./Options');

var _Options2 = _interopRequireDefault(_Options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipContainer = (0, _styledComponents2.default)(_metrixCommon.Container)(_templateObject);

var WorkflowToolTip = function (_React$Component) {
    _inherits(WorkflowToolTip, _React$Component);

    function WorkflowToolTip() {
        _classCallCheck(this, WorkflowToolTip);

        return _possibleConstructorReturn(this, (WorkflowToolTip.__proto__ || Object.getPrototypeOf(WorkflowToolTip)).apply(this, arguments));
    }

    _createClass(WorkflowToolTip, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return !(0, _fastDeepEqual2.default)(this.props, nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var toolTip = (0, _metrixCommon.getElementsByType)(this.props.component.elements, 'toolTip');
            var mode = (0, _metrixCommon.getElementValueByType)(toolTip, 'type');
            var label = (0, _metrixCommon.getElementsByType)(toolTip, 'label');

            var content = null;

            switch (mode) {
                case 'simple':
                    content = _react2.default.createElement(_metrixCommon.Label, { textAlign: _metrixCommon.Alignments.left, text: (0, _metrixCommon.getElementValueByType)(label, 'text') });
                    break;
                case 'advanced':
                    var items = toolTip.filter(function (x) {
                        return x.type !== 'type';
                    });
                    content = [];
                    items.map(function (item, i) {
                        return content.push(_react2.default.createElement(_Component2.default, { key: _this2.props.component.code + '.item.' + i, inline: true, component: { code: _this2.props.component.code, value: item.value, type: item.type, elements: item.elements } }));
                    });
                    break;
                case 'options':
                    var optionsTooltip = (0, _metrixCommon.getElementByType)(this.props.component.elements, 'toolTip');
                    content = _react2.default.createElement(_Options2.default, { component: _extends({}, optionsTooltip) });
                    break;
            }

            return _react2.default.createElement(
                _metrixCommon.Container,
                { fullSize: true, verticalAlignment: this.props.component.type === 'header' ? _metrixCommon.Alignments.center : _metrixCommon.Alignments.bottom },
                _react2.default.createElement(
                    TooltipContainer,
                    null,
                    _react2.default.createElement(
                        _metrixCommon.ToolTip,
                        { mode: mode !== 'simple' && 'modal' },
                        content
                    )
                )
            );
        }
    }]);

    return WorkflowToolTip;
}(_react2.default.Component);

exports.default = WorkflowToolTip;